function selectBase(state) {
  return state.reports.components
}

const EMPTY_OBJECT = {}
export function selectComponentStateById(state, props) {
  return selectBase(state).byId[props.id] || EMPTY_OBJECT
}
